export enum Roles {
  ADMIN = "Admin",
  VENDOR = "Vendor",
  CONTRACTOR = "Contractor",
  CLIENT = "Client",
  MEMBER = "Member",
}
